import { ICycle } from 'v2/resources/types/cycles';

export interface IStatusCycles {
  cycles: Array<ICycle>;
}
export const initialState: IStatusCycles = {
  cycles: [],
};
